import React from 'react';

import { REJECTION_MESSAGES } from '../utils/ppqDataUtils';

const PPQNegativeOutcome = ({ failedReasons }) => {
  delete failedReasons.result;
  const failedKeys = Object.keys(failedReasons);

  return (
    <div>
      <h1>Unfortunately, it doesn't appear that your homeowner would qualify for a Hometap Investment.</h1>
      <p>
        According to the information you provided, we would be unable to work with your homeowner for the following
        reasons:
      </p>
      <ul>
        {failedKeys.map((reason) => {
          return <li key={reason}>{REJECTION_MESSAGES[reason]}</li>;
        })}
      </ul>
    </div>
  );
};

export default PPQNegativeOutcome;
